export function isISOString(value) {
    try {
        return new Date(value).toISOString() === value;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=iso8601.js.map